import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;

const ViewOneFiles = () => {
  const [userData, setUserData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [fileName, setFileName] = useState(null);

  const { fileId } = useParams(); // Get the file name from route params

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    // Fetch file details using the specific file's name
    fetch(`https://cliqestimatebuilder.com/waiver_admin/files/${fileId}`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setFileDetails(data.data.excel_data); // Update the state with fetched file details
        setFileName(data.data.title);
      })
      .catch((error) => {
        console.error("Error fetching file details:", error);
      });
  }, [fileId]);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewOne">
            <div className="viewOneLeft">
              <Link to="/view-files">
                <img src={backBtn} alt="image" />
              </Link>
              <h3>{fileName}</h3>
            </div>
            <div className="viewOneRight">
              <Link
                to={{
                  pathname: `/create-form/${fileId}`, // Use fileId here
                  state: { fileData: fileDetails }, // Pass fileDetails here if needed
                }}
                className="createFormBtn vwOneBtn"
              >
                Create Form
              </Link>
            </div>
          </div>
          <div className="viewBox">
            <ul className="previewOne">
              {fileDetails &&
                fileDetails[0] &&
                Object.entries(fileDetails[0]).map(([label, value]) =>
                  value === "Job code" ||
                  value === "Total price" ||
                  value === "Customer" ||
                  value === "Customer PO#" ||
                  value === "Metal" ||
                  value === "Finger Size" ||
                  value === "Contact email" ||
                  value === "Release notes" ||
                  value === "PLAT Metal Credit" ||
                  value === "14K Metal Credit" ||
                  value === "18K Metal Credit" ? (
                    <li key={label}>
                      <label>
                        {value === "Release notes"
                          ? "Job description and Notes"
                          : value}
                        :
                      </label>
                      <div className="dscFile">{fileDetails[1][label]}</div>
                    </li>
                  ) : null
                )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOneFiles;
